import { Row, Col } from 'antd';
import { TeacherType } from './types';
import TeacherTable from './TeacherTable';

type Props = {
  teacherInfo: TeacherType;
  getAllTeacherAccountFunction: Function;
}

function TeacherSingle(props: Props) {
  const { teacherInfo, getAllTeacherAccountFunction } = props;

  return (
    <Row gutter={[8, 0]} justify="center">
      <Col span={24}>
        <TeacherTable
          teacherArray={[teacherInfo]}
          fetchTeacherFunction={getAllTeacherAccountFunction}
        />
      </Col>
    </Row>
  )
}

export default TeacherSingle;